import { connect } from 'react-redux'
import { compose, withProps, mapProps, withState } from 'recompose'
import omit from 'lodash/fp/omit'
import shortid from 'shortid'

import withSocialLogin from 'common/auth/Shared/withSocialLogin'
import { login } from 'auth/modules/auth'
import CONFIG from 'app-config'
import notif from 'services/notification'
import noScroll from 'no-scroll'

export default compose(
  connect(null, { login }),

  withState('key', 'changeKey', shortid.generate()),

  withProps(({ login, provider, onSuccess = () => {}, changeKey }) => ({
    provider,
    variant: provider,
    appId: {
      facebook: CONFIG.FACEBOOK_APP_ID,
      google: CONFIG.GOOGLE_CLIENT_ID,
    }[provider],
    onLoginSuccess: ({ token: t }) => {
      login(
        '',
        {
          facebook: `facebook:${t.accessToken}`,
          google: `googlejwt:${t.idToken}`,
        }[provider],
      )
        .then(() => {
          notif.success({ title: 'Login successful' })
          onSuccess()
        })
        .then(noScroll.off())
        .catch((error) =>
          notif.error({
            title: 'Login failed',
            message: 'please try again',
            error,
          }),
        )
    },
    onLoginFailure: (error) => {
      notif.error({
        title: 'Authentication failed',
        message: 'please try again',
        error,
      })

      changeKey(shortid.generate())
    },
  })),

  withSocialLogin,

  withProps((props) => ({
    onClick: props.triggerLogin,
  })),

  mapProps(omit(['onSuccess'])),
)
